'use client';

import { useState } from 'react';

const COLORS = {
  bg: '#f3f2f2',
  surface: '#eae9e9',
  text: '#201e1d',
  accent: '#ec3013',
  accent700: '#ae1800',
  divider: 'rgba(32,30,29,.4)',
  neutral500: '#9b9797',
  link: '#2563eb',
};

export default function LoginClient({ redirectTo }: { redirectTo?: string }) {
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr('');
    setSubmitting(true);
    const res = await fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ loginId, password }),
    });
    const data = await res.json();
    setSubmitting(false);
    if (res.ok) {
      // redirectTo(캐치된 페이지로 돌아가기)는 구매회원 흐름에서만 의미가 있다 —
      // 영업자/관리자는 항상 각자의 관리 대시보드로 이동.
      const dest = data.role === 'buyer' ? (redirectTo || data.redirect) : data.redirect;
      window.location.href = dest;
    } else {
      setErr(data.error ?? '로그인에 실패했습니다.');
    }
  };

  return (
    <div style={{ minHeight: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', padding: '36px 16px', background: COLORS.bg, fontFamily: '-apple-system, "Pretendard", "Malgun Gothic", system-ui, sans-serif' }}>
      <div style={{ width: '100%', maxWidth: 400, background: COLORS.bg, border: `2px solid ${COLORS.divider}`, padding: 32 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <h1 style={{ fontSize: 20, fontWeight: 400, color: COLORS.text, margin: 0 }}>로그인</h1>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label style={{ display: 'block', fontSize: 12, marginBottom: 5, color: 'rgba(32,30,29,.7)' }}>아이디</label>
            <input
              required
              autoFocus
              value={loginId}
              onChange={e => setLoginId(e.target.value)}
              placeholder="아이디"
              style={{ width: '100%', minHeight: 40, padding: '8px 12px', fontSize: 14, color: COLORS.text, background: COLORS.surface, border: `1px solid ${COLORS.divider}`, borderRadius: 0 }}
            />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 12, marginBottom: 5, color: 'rgba(32,30,29,.7)' }}>비밀번호</label>
            <input
              required
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="비밀번호"
              style={{ width: '100%', minHeight: 40, padding: '8px 12px', fontSize: 14, color: COLORS.text, background: COLORS.surface, border: `1px solid ${COLORS.divider}`, borderRadius: 0 }}
            />
          </div>

          {err && <p style={{ color: COLORS.accent700, fontSize: 12, margin: 0 }}>{err}</p>}

          <button
            type="submit"
            disabled={submitting}
            style={{ marginTop: 6, height: 46, background: COLORS.accent, color: COLORS.bg, border: 'none', fontSize: 14, fontWeight: 400, cursor: 'pointer', opacity: submitting ? 0.6 : 1 }}
          >
            {submitting ? '로그인 중...' : '로그인'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, whiteSpace: 'nowrap' }}>
          <a href="/join/buyer" style={{ color: COLORS.link }}>구매회원 가입</a>
          <span style={{ color: COLORS.divider }}>|</span>
          <a href="/join/seller" style={{ color: COLORS.link }}>영업회원 가입</a>
          <span style={{ color: COLORS.divider }}>|</span>
          <a href="/find-account" style={{ color: COLORS.link }}>아이디 / 비밀번호 찾기</a>
        </div>
      </div>
    </div>
  );
}
